import React from "react";
import PropTypes from "prop-types";
import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import styles from "../SecurityShared.module.scss";

const DeviceItem = ({
  device,
  isQueuedForRemoval,
  isRemovable,
  onRemove,
  showHorizontalRule,
}) => {
  const { l10n } = useLocalization();
  const iconForDeviceType = (d) => {
    if (d.device_type === "mobile" || d.id.includes("TOTPDevice"))
      return "smartphone";
    else if (d.name === "Email") return "mail";
    else if (d.id.includes("StaticDevice") || d.name === "Backup codes")
      return "security";
    return "smartphone";
  };
  return (
    <>
      <div className={styles["device-details"]}>
        <div style={{ display: "flex" }}>
          <span
            className={`narmi-icon-${iconForDeviceType(device)} ${
              styles["mfa-device-icon"]
            }`}
          />
          <p>{device.name}</p>
        </div>
        {isRemovable && (
          <div>
            <Button
              testId="remove-mfa-device"
              kind="negative"
              onClick={() => onRemove(device)}
            >
              {isQueuedForRemoval 
                ? l10n.getString("button-confirm-remove")
                : l10n.getString("button-remove")}
            </Button>
          </div>
        )}
      </div>
      {showHorizontalRule && <hr />}
    </>
  );
};
DeviceItem.propTypes = {
  device: PropTypes.object.isRequired,
  isQueuedForRemoval: PropTypes.bool.isRequired,
  isRemovable: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  showHorizontalRule: PropTypes.bool.isRequired,
};

export default DeviceItem;
